import { Box, Chip, Typography } from "@mui/joy";
import { memo } from "react";
import { type RuleBasedAudienceCombinatorOperator } from "features/mediaDataRoom/models";
import {
  mapCombinatorOperatorToIcon,
  mapCombinatorOperatorToPresentation,
} from "../../config";

export interface CombinatorChipProps {
  operator: RuleBasedAudienceCombinatorOperator;
}

const CombinatorChip = memo<CombinatorChipProps>(({ operator }) => {
  const Icon = mapCombinatorOperatorToIcon[operator];
  return (
    <Chip size="lg" sx={{ my: 1 }}>
      <Box alignItems="center" display="flex">
        <Icon width="20px" />
        <Typography level="body-sm" ml={0.5}>
          {mapCombinatorOperatorToPresentation[operator]}
        </Typography>
      </Box>
    </Chip>
  );
});

CombinatorChip.displayName = "CombinatorChip";

export default CombinatorChip;
